var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row one-tariff mb-2",on:{"click":function($event){return _vm.selectTariff()}}},[_c('div',{staticClass:"col-8 align-self-center pl-1"},[_c('div',{staticClass:"row name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }